import {Component, Pipe, PipeTransform, OnInit} from '@angular/core';
import {EditDataService} from "./services/edit-data.service";
import {DomSanitizer} from "@angular/platform-browser";
import {DataService} from "./services/data.service";
/**
 * Review
 * Todo:
 * Использвать одни и те же кавычки, либо " либо '
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']

})
export class AppComponent implements OnInit {
  constructor(public editDataService: EditDataService,
              private dataService: DataService) {
  }

  ngOnInit() {

      let session = localStorage.getItem("clientId");
      if (session) {
         this.dataService.getPersonalCabinetData().subscribe(
           (data) => { },
           (error) => {
             localStorage.removeItem('clientId');
           });
    }
  }
}


@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/app.component.ts